var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',[_c('DeliverySummaryForm',{attrs:{"src":_vm.item,"is-last":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }